export default __webpack_public_path__ + "static/proxima-nova-300-2cc8c23180735fb453cf2acc7b41dcb2.woff";